
import Layout from "../components/Layout";
import { ExternalLink } from "lucide-react";

const Enjoy = () => {
  return (
    <Layout>
      <div className="layout py-12">
        <div className="max-w-3xl mx-auto">
          {/* Logo */}
          <div className="flex justify-center mb-8">
            <a 
              href="https://joinenjoy.co" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <img 
                src="/Asset 27@2x 1.png" 
                alt="Enjoy Logo" 
                className="h-16"
              />
            </a>
          </div>

          {/* Product Screenshot */}
          <div className="mb-12 rounded-lg overflow-hidden">
            <img 
              src="/enjoy_screen.png" 
              alt="Enjoy App Screenshot" 
              className="w-full h-auto"
            />
          </div>
          
          <div className="space-y-6 text-[16px] text-[#000000]">
            <p>
              We're creating a space where people connect over the things they enjoy. Enjoy is for media lovers to chat, review, and save all their favorite books, movies, TV shows, and music in one place.
            </p>
            
            <p>
              Hop into the #Books chat to talk about ACOTAR. Leave a review for Frankenstein or Friends. Create a joylist, name it "it's beginning to look a lot like…" and add your favorite holiday movies, books, TV shows, and music, then share with friends.
            </p>
            
            <p className="font-medium">
              We're here for your joy, so skip the outrage and join enjoy!
            </p>
          
            <div className="flex items-center mt-8 group">
              <ExternalLink className="w-5 h-5 mr-3 text-[#5D7DFF] group-hover:text-[#C7CCFF] transition-colors" />
              <a 
                href="https://www.enjoy.inc" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#5D7DFF] hover:text-[#C7CCFF] transition-colors"
              >
                enjoy.inc
              </a>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Enjoy;
